<template>
  <tr class="row__share">
    <td class="data__label">
      <p v-html="$t('dashboard.pageShare.register.label')"></p>
    </td>
    <td colspan="7" class="data__input">
      <div>
        <ui-input-text
          type="text"
          :isInputAbove="false"
          :placeholder="'Beusable ID'"
          :modelValue="model.userId"
          :modelError="modelError.userId"
          @input="model.userId = $event"
          @onFocus="modelError.userId = ''"/>
        <ui-button
          primary2
          size="small"
          @click="onShare">{{ $t('common.share') }}</ui-button>
      </div>
      <ul class="shared-list">
        <li class='list-item' v-for="(item, index) in setSharedUserIdList" :key="index">
          {{ item.userId }}
          <i class="icon icon--close14" tabindex="0" @click="showRemoveLayer(item)"></i>
        </li>
      </ul>
    </td>
    <td class="data__close">
      <ui-button
        circle
        iconName="icon--close-size16"
        @click="destroyShareRowComponent"/>

      <dimmed v-if="useDimmed">
        <div class="remove-layer--wrap">
          <i class="icon icon--dialog-warning"></i>
          <p class="title" v-html="$t('dashboard.pageShare.removeLayer.title')"></p>
          <p class="description" v-html="$t('dashboard.pageShare.removeLayer.desc.before', {removeUserName})"></p>
          <div class="button--wrap">
            <ui-button @click="closeRemoveLayer">{{ $t('common.cancel') }}</ui-button>
            <ui-button primary2 @click="onRemove">{{ $t('common.remove') }}</ui-button>
          </div>
        </div>
      </dimmed>
    </td>
  </tr>
</template>

<script>
import UiButton from '@/components/ui/UiButton'
import UiInputText from '@/components/ui/UiInputText'
import Dimmed from '@/components/ui/Dimmed'
import { shareList, shareCheck, shareAdd, shareRemove } from '@/api/apply'

export default {
  components: {
    UiButton,
    UiInputText,
    Dimmed
  },
  props: [
    'applyData'
  ],
  data () {
    return {
      model: {
        userId: ''
      },
      modelError: {
        userId: ''
      },
      sharedUserIdList: [],
      isShowRemoveLayer: false,
      removeUserId: '',
      removeUserName: ''
    }
  },
  computed: {
    useDimmed () {
      return this.isShowRemoveLayer
    },
    setSharedUserIdList () {
      return this.sharedUserIdList
    }
  },
  methods: {
    onApplyChange (key, value) {
      this.$emit('onApplyChange', {
        apply: this.applyData,
        key,
        value
      })
    },
    onApplyMetaChange (key, value) {
      this.$emit('onApplyMetaChange', {
        meta: this.applyData.meta,
        key,
        value
      })
    },
    getSharedUserIdList () {
      shareList(this.applyData.id).then((response) => {
        if (response.length) {
          this.onApplyChange('shared', true)
        } else {
          this.onApplyChange('shared', false)
        }
        this.sharedUserIdList = response
      })
    },
    onShare () {
      const aid = this.applyData.id
      let userId = this.model.userId.trim()
      let param = {
        aid: aid,
        data: {
          userId: userId
        }
      }

      if (!this.model.userId.trim().length) {
        this.modelError.userId = 'requireBeuId'
        return false
      }

      // post: check
      shareCheck(param).then(() => {
        shareAdd(param).then(response => {
          this.sharedUserIdList.push(response)
          this.model.userId = ''
          this.getSharedUserIdList()
        })
      }).catch(err => {
        if (err.message === 'Not my page.') {
          alert('Not my page')
          return false
        }
        if (err.message === 'Already invited.') {
          this.modelError.userId = 'alreadySharedBeuId'
          return false
        }
        if (err.message === 'Cannot share page myself.' ||
          err.message === 'Not found user.') {
          this.modelError.userId = 'incorrectBeuId'
          return false
        }
      })
    },
    showRemoveLayer (item) {
      this.removeUserId = item._id
      this.removeUserName = item.userId
      this.isShowRemoveLayer = true
    },
    onRemove () {
      const iid = this.removeUserId
      shareRemove(iid).then(response => {
        this.isShowRemoveLayer = false
        this.getSharedUserIdList()
      }).catch(err => {
        console.error(err)
      })
    },
    closeRemoveLayer () {
      this.removeUserId = ''
      this.isShowRemoveLayer = false
    },
    destroyShareRowComponent () {
      this.onApplyMetaChange('isShowShareRow', false)
    }
  },
  created () {
    this.getSharedUserIdList()
  }
}
</script>

<style lang="scss" scoped="scoped">
.row__share {
  .data__label {
    border-top: none;
    text-align: right;
    color: #2f2f2f;
    vertical-align: top;
    padding-top: 34px;
    font-weight: 500;
    /deep/ .marking {
      color: $brandColor;
    }
  }
  .data__input {
    vertical-align: top;
    padding-top: 21px;
    text-align: left;
    padding-left: 10px;

    .input--wrap {
      width: 294px;
      vertical-align: middle;

      /deep/ label.label {
        display: none;
      }
    }

    .ui-btn {
      vertical-align: middle;
      margin-left: 5px;
    }

    .shared-list {
      margin-top: 30px;
      margin-bottom: 30px;

      .list-item {
        overflow: hidden;
        position: relative;
        display: inline-block;
        min-width: 156px;
        height: 30px;
        line-height: 32px;
        border-radius: 6px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15), 0 0 1px 0 rgba(0, 0, 0, 0.4);
        background-color: #f9f9f9;
        padding-left: 8px;
        padding-right: 30px;
        box-sizing: border-box;
        margin-right: 10px;
        margin-bottom: 15px;
        color: #444;

        &.hover {
          &:after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.06);
          }
        }

        .icon {
          @include positionYcenter;
          right: 0px;
          background-color: transparent;
          background-size: 14px 14px;
          background-position: center center;
          padding: 8px;
          outline: none;
        }
      }
    }
  }
  .remove-layer--wrap {
    width: 430px;
    box-sizing: border-box;
    padding: 50px 40px 37px 40px;
    border-radius: 14px;
    box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
    background-color: #ffffff;
    text-align: center;

    .icon {
      margin-bottom: 13px;
    }

    .title {
      font-size: 20px;
      font-weight: 600;
      color: #444;
      margin-bottom: 10px;
      line-height: 1.2;
    }

    .description {
      font-size: 14px;
      color: #2f2f2f;
      margin-bottom: 28px;
      line-height: 1.43;
      white-space: pre-line;
      word-break: break-all;

      /deep/ span {
        color: $brandColor;
      }
    }

    .button--wrap {
      button {
        margin: 0 3px;
      }
    }
  }
}
</style>
